// extracted by mini-css-extract-plugin
module.exports = {"videosWrapper":"Videos_videosWrapper__2eoQD"};